import { EditableContactInfo } from "../components/EditableContactInfo";
import { VehicleCardDetails } from "@/types/vehicleCard";
import { VehicleCardComments } from "../VehicleCardComments";
import { VehicleCardCarDetails } from "../VehicleCardCarDetails";
import { VehicleCardPriceInfo } from "../VehicleCardPriceInfo";
import { VehicleCardValueEstimation } from "../VehicleCardValueEstimation";
import { getLanguage } from "@/utils/languageUtils";
import { commonMiscLabels, vehicleCardUILabels } from "@/i18n";

interface CardCardInfoTabProps {
  vehicleCard: VehicleCardDetails;
}

export const CarCardsInfoTab = ({ vehicleCard }: CardCardInfoTabProps) => {
  const vcLabels = vehicleCardUILabels(getLanguage());
  return (
    <div className="space-y-4">
      {/* Contact info and comments - stacked on mobile, side by side on desktop */}
      <div className="grid gap-4 grid-cols-1 md:grid-cols-2">
        <div className="space-y-4">
          <EditableContactInfo
            vehicleCardId={vehicleCard.id}
            customerName={vehicleCard.owner?.username || ""}
            email={vehicleCard.owner?.email}
            phone={vehicleCard.owner?.phoneNumber}
            postalCode={`${vehicleCard.owner?.address?.street || ""} ${
              vehicleCard.owner?.address?.zipCode || ""
            } ${vehicleCard.owner?.address?.city || ""}`.trim()}
            labelOverrides={{
              postalCode: commonMiscLabels(getLanguage()).fullAddress,
            }}
          />
          <VehicleCardComments
            comments={vehicleCard.comments || []}
            vehicleCardId={vehicleCard.id}
          />
        </div>

        {/* Car details - full width on mobile */}
        <div className="space-y-4">
          <VehicleCardCarDetails
            id={vehicleCard.id}
            vehicleDetails={vehicleCard.vehicleDetails}
          />
        </div>
      </div>

      {vehicleCard.priceInfo ? (
        <VehicleCardPriceInfo
          expectedPrice={vehicleCard.priceInfo.expectedPrice || "0"}
          purchasePrice={vehicleCard.priceInfo.purchasePrice || "0"}
          marketPrice={vehicleCard.priceInfo.marketPrice || "0"}
        />
      ) : (
        <div className="p-4 border rounded-lg bg-muted/50">
          <p className="text-sm text-muted-foreground">
            {vcLabels.noPriceInfo}
          </p>
        </div>
      )}
      {vehicleCard.valueEstimation ? (
        <VehicleCardValueEstimation
          valueData={vehicleCard.valueEstimation?.valueData || []}
          ratingIntervalsRaw={vehicleCard.valueEstimation?.ratingIntervalsRaw}
          vehicleCardId={vehicleCard.id}
          vehicleCard={vehicleCard}
        />
      ) : (
        <div className="p-4 border rounded-lg bg-muted/50">
          <p className="text-sm text-muted-foreground">
            {vcLabels.noValueEstimationInfo}
          </p>
        </div>
      )}
    </div>
  );
};
